import React, {useState} from 'react'
import { renderStatementWithKaTeX } from "../../../../Status";
import { SiOverleaf } from "react-icons/si";
import LoadingPage from '../../../../Error/LoadingPage/LoadingPage';

import {
  add2DiscussionMessage,
  awardPointsToStudent,
  creatSubmissionSession,
  UpdateSubmission,
} from "../../../../Functions/CRUD/Submission/submissionHelper";
import { useNavigate } from "react-router-dom";

const Keyboard = ({
  referenceCode,
  studentId,
  TypeOfPost,
  poster
}) => {
    const [ResultUpdate, setResultUpdate] = useState("in process")
  const [loading, setloading] = useState(false)
  const [StudentsTrial, setStudentsTrial] = useState("");
  const [Image, setImage] = useState(null);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const MAX_FILE_SIZE =1*1024*1024; // 1 MB in bytes

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
     if (file.size > MAX_FILE_SIZE) {
    setMessage("❌ File too large! Please upload an image smaller than 1MB.");
    e.target.value = null; // reset input
    setImage(null);
    return;
  }
    if (["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
      convertToBase64(file).then((base64String) => setImage(base64String));
      setMessage("");
    } else {
      setImage(null);
      e.target.value = null; // reset input
      setMessage(
        "🚩 Only images are accepted. Meaning eligeable file types are : [ .jpeg , .png , .jpg ]"
      );
    }
  };
  

  /* On Submit Variables */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setloading(true);
    const messageData = {
      classType: TypeOfPost,
      poster: {
        id: poster._id,
        name: poster.username,
        role: poster.role.trim().toLowerCase(),
      },
      /* dateOfSubmission : new Date(), */
      content: StudentsTrial,
      image: Image, // base64 string or null
    };
    console.log(messageData)

      const response = await add2DiscussionMessage(
        referenceCode,
        studentId,
        messageData
      );
    const ChangeResult = await UpdateSubmission(referenceCode, studentId, {
            result: ResultUpdate,
          });

        if(ResultUpdate==="correct") { 
            const awardStudent= await awardPointsToStudent(studentId,{referenceCode:referenceCode})
        }

    setStudentsTrial("");
    setImage(null);
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: 'auto' or 'smooth'
    });

    navigate(0);
    navigate(window.location.pathname, { replace: true });
  };

  if (loading) {
    return <LoadingPage/>;
  }

  return (
    <div className="SubmissionKeyboard-container">
        <div className="SubmissionStatus">
          <h2>Submission Status :</h2>
          <select
          required
            value={ResultUpdate} name=""
            id=""
            onChange={(e) => setResultUpdate(e.target.value)}
          >
            <option disabled selected value="">
              Select...
            </option>
            <option value="correct">Correct</option>
            <option value="in process">In Process</option>
            <option value="incorrect">Incorrect</option>
          </select>
        </div>
          <div className="DisplayBox">
            {renderStatementWithKaTeX(StudentsTrial)}
          </div>
          <div className="LaTeX-buttons-container">
            <div className="LaTeX-buttons">
              <button onClick={() => setStudentsTrial((prev) => prev + "$x$")}>
                {renderStatementWithKaTeX("$x$")}
              </button>
              <button onClick={() => setStudentsTrial((prev) => prev + "$\\pi$")}>
                {renderStatementWithKaTeX("$\\pi$")}
              </button>
    
              <button
                onClick={() => setStudentsTrial((prev) => prev + "$\\frac{a}{b}$")}
              >
                {renderStatementWithKaTeX("$\\frac{a}{b}$")}
              </button>
              <button onClick={() => setStudentsTrial((prev) => prev + "$a^2$")}>
                {renderStatementWithKaTeX("$a^2$")}
              </button>
              <button onClick={() => setStudentsTrial((prev) => prev + "$a^b$")}>
                {renderStatementWithKaTeX("$a^b$")}
              </button>
              <button
                onClick={() => setStudentsTrial((prev) => prev + "$\\sqrt{a}$")}
              >
                {renderStatementWithKaTeX("$\\sqrt{a}$")}
              </button>
              <button
                onClick={() => setStudentsTrial((prev) => prev + "$\\sqrt[b]{a}$")}
              >
                {renderStatementWithKaTeX("$\\sqrt[b]{a}$")}
              </button>
    
              <button onClick={() => setStudentsTrial((prev) => prev + "$a_{n}$")}>
                {renderStatementWithKaTeX("$a_{n}$")}
              </button>
              <button
                onClick={() => setStudentsTrial((prev) => prev + "$\\infty$")}
              >
                {renderStatementWithKaTeX("$\\infty$")}
              </button>
              <button onClick={() => setStudentsTrial((prev) => prev + "$\\sum$")}>
                {renderStatementWithKaTeX("$\\sum$")}
              </button>
              <button onClick={() => setStudentsTrial((prev) => prev + "$\\prod$")}>
                {renderStatementWithKaTeX("$\\prod$")}
              </button>
              <button onClick={() => setStudentsTrial((prev) => prev + "$\\int$")}>
                {renderStatementWithKaTeX("$\\int$")}
              </button>
              <button
                onClick={() => setStudentsTrial((prev) => prev + "$\\implies$")}
              >
                {renderStatementWithKaTeX("$\\implies$")}
              </button>
              <button onClick={() => setStudentsTrial((prev) => prev + "$\\iff$")}>
                {renderStatementWithKaTeX("$\\iff$")}
              </button>
    
              <button
                onClick={() => setStudentsTrial((prev) => prev + "$\\{x\\}$")}
              >
                {renderStatementWithKaTeX("$\\{x\\}$")}
              </button>
              <button
                onClick={() =>
                  setStudentsTrial((prev) => prev + "$\\lfloor x\\rfloor$")
                }
              >
                {renderStatementWithKaTeX("$\\lfloor x\\rfloor$")}
              </button>
              <button
                onClick={() =>
                  setStudentsTrial((prev) => prev + "$\\lceil x \\rceil$")
                }
              >
                {renderStatementWithKaTeX("$\\lceil x \\rceil$")}
              </button>
              <button onClick={() => setStudentsTrial((prev) => prev + "$\\in$")}>
                {renderStatementWithKaTeX("$\\in$")}
              </button>
              <button
                onClick={() => setStudentsTrial((prev) => prev + "$\\angle ABC$")}
              >
                {renderStatementWithKaTeX("$\\angle ABC$")}
              </button>
              <button
                onClick={() => setStudentsTrial((prev) => prev + "$\\equiv$")}
              >
                {renderStatementWithKaTeX("$\\equiv$")}
              </button>
    
                            <button className="LatexSupport" onClick={()=>window.open("https://drive.google.com/file/d/1AdxlefgjFZL0HYDjOZi7jF_dUyOXWrVO/view?usp=sharing", "_blank")}> 

                <SiOverleaf />
              </button>
            </div>
          </div>
          <form action="" onSubmit={handleSubmit}>
            <textarea
              required
              defaultValue={""}
              type="text"
              placeholder="Start writing your solution over here ..."
              value={StudentsTrial}
              onChange={(e) => {setStudentsTrial(e.target.value)}}
            />
            <div className="PinnedFiles">
              <h2>
                Pinned Files : {Image === null ? "(No file is pinned.)" : null}{" "}
              </h2>
              {Image != null ? (
                <div className="ImageContainer">
                  <img src={Image} alt="" />
                </div>
              ) : null}
              {message && <p className="Error">{message}</p>}
    
              <input
                type="file"
                label="Image"
                name="myFile"
                accept=".jpeg, .png, .jpg"
                id="file-upload"
                onChange={handleFileChange}
              />
              <label htmlFor="file-upload" className="custom-file-upload">
                📂 Choose an Image
              </label>
            </div>
    
            <button
              type="submit"
              className="Submit-button" /* onClick={test.role!="Student"?()=>{setCorrectionStatus(PrimarySubmissionStatus)}:null} */
            >
              Submit
            </button>
          </form>
        </div>
  )
}

export default Keyboard

function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}

